<template>
  <div>
    <v-menu top right offset-y 
      :close-on-content-click="false"
      v-model="openPicker"
      transition="slide-x-transition"
    >
      <template v-slot:activator="{ on }">
        <v-icon medium v-on="on">insert_emoticon</v-icon>
      </template>

      <v-card>
        <div id="emoji"></div>
      </v-card>

    </v-menu>
  </div>
</template>

<style>
  #emoji {
    width: 358px;
    height: 400px;
  }
  .ep-c {
    margin: 0 3px;
    height: 36px !important;
  }
</style>

<script>
  import EmojiPanel from 'emoji-panel'

  export default {
    name: 'emoji-picker',
    data () {
      return {        
        openPicker: false
      }
    },
    props: {
      callback: Function
    },
    methods: {
      onEmojiClicked() {
        this.openPicker = true
      },
      onEmojiSelected(e) {
        console.log(e)
        this.openPicker = false
        this.callback(e)
      }
    },
    mounted() {
      this.$nextTick(() => {
        let $el = document.getElementById('emoji')
        new EmojiPanel($el, {
          onClick: this.onEmojiSelected
        })
      })
    }
  }
</script>